import { BaseModel, Paging } from '@Core';
import { Stack, SxProps, Theme, Pagination as MuiPagination, CircularProgress, Grow, Box, Fade } from '@mui/material';
import ListNoData from '@pages/cameras/list/components/NoDataCameras';
import React, { ReactNode } from 'react';
import TableSkeleton from './tables/TableSkeleton';

type Props<T extends BaseModel> = {
    paging: Paging<T>;
    styleContainer?: SxProps<Theme>;
    isLoading?: boolean;
    setPage: (page: number) => void;
    tableComponent?: JSX.Element;
    noDataComponent?: ReactNode;
    textNoData?: string;
};

export default function BaseTableRender<T extends BaseModel>(props: Props<T>) {
    const { paging, setPage, isLoading } = props;
    return (
        <Stack sx={{ ...props.styleContainer }}>
            {isLoading ? (
                // <TableSkeleton />
                <Stack direction="row" justifyContent="center" alignItems="center" mt={10}>
                    <Fade in={true} timeout={Math.min(500, 1000)}>
                        <Box height={'100%'}>
                            <CircularProgress />
                        </Box>
                    </Fade>
                </Stack>
            ) : paging.rows.length ? (
                <Fade in={true} timeout={Math.min(500, 1000)}>
                    <Box height={'100%'}>{props.tableComponent}</Box>
                </Fade>
            ) : (
                props.noDataComponent ?? (
                    <Fade in={true} timeout={Math.min(500, 1000)}>
                        <Box height={'100%'}>
                            <ListNoData changeText={props.textNoData} />
                        </Box>
                    </Fade>
                )
            )}

            {paging.totalPages > 1 && !isLoading && (
                <Stack mt={3} direction={'row'} justifyContent="center">
                    <MuiPagination
                        count={paging.totalPages || 1}
                        page={paging.page}
                        onChange={(_, page) => setPage(page)}
                        variant="outlined"
                        shape="rounded"
                    />
                </Stack>
            )}
        </Stack>
    );
}
